import { gql } from "@apollo/client";

export const CLEAN_CLAIM_PACKAGES = gql`
	query (
		$operatorId: ID!
		$recipientMobile: String
		$waybillNumber: String
		$startDate: Date
		$endDate: Date
		$packageStateNo: Int
		$lockerId: ID
	) {
		cleanClaimPackages(
			operatorId: $operatorId
			recipientMobile: $recipientMobile
			waybillNumber: $waybillNumber
			startDate: $startDate
			endDate: $endDate
			packageStateNo: $packageStateNo
			lockerId: $lockerId
		) {
			packageId
			statusDate
			senderMobile
			partnerAgentMobile
			senderName
			recipientMobile
			packageDate
			pickupByDate
			waybillNumber
			packageStateNo
			packageDate
			lockerLocation
			locker {
				lockerId
			}
		}
	}
`;

export const LOCKERS_FOR_LOCKER_CLEAN_UP = gql`
	query ($operatorId: ID!) {
		lockers(operatorId: $operatorId) {
			lockerName
			lockerId
			supportStationId
		}
	}
`;

export const GET_LOCKERS_BY_ID_FOR_LOCKER_CLEAN_UP = gql`
	query ($operatorId: ID!, $lockerId: ID) {
		lockers(operatorId: $operatorId, lockerId: $lockerId) {
			lockerId
			onsiteContact4
			contactMobile4
			onsiteContact5
			contactMobile5
			onsiteContact6
			contactMobile6
		}
	}
`;

export const SUPPORT_STATIONS = gql`
	query ($supportStationId: ID!) {
		supportStation(supportStationId: $supportStationId) {
			supportStationId
			supervisor
			supervisor2
			mobile
			mobile2
		}
	}
`;
